export type AnalysisLanguage = 'uz' | 'ru' | 'en';

const SUPPORTED: readonly string[] = ['uz', 'ru', 'en'];

/** The language the explanation is written in: the app's own, reduced to the three the API accepts. Uzbek is the app default. */
export function analysisLanguage(code: string | undefined): AnalysisLanguage {
  const base = (code ?? '').toLowerCase().split(/[-_]/)[0];
  return (SUPPORTED.includes(base) ? base : 'uz') as AnalysisLanguage;
}
